import BasicValidation from 'components/components/common/BasicValidation';
import isEmpty from 'lodash/isEmpty';
import mergeErrors from 'components/helpers/mergeErrors';
import find from 'lodash/find';
import TransHelper from 'components/common/translations/TransHelper';

export default class CustomerAddressValidation extends BasicValidation {
  constructor(params, busStops, locale = "en") {
    super();
    this.params = params;
    if (this.isBusStop()) {
      this.params.street = this.params.selectedObject.value;
      var bus = find(busStops, (o, key) => key === this.params.street);
      this.params.lat = bus.lat;
      this.params.lng = bus.lng;
    } else {
      this.params.street = this.params.selectedObject.label;
      this.params.googlePlaceId = this.params.selectedObject.value;
    }
    this.locale = locale
  }

  trans(key, prefix = 'content.errors.auth.customerAddressValidation') {
    return TransHelper.translate(this.locale, prefix + '.' + key);
  }

  isBusStop() {
    return this.isEmptyValue(this.params.selectedObject.g);
  }

  validationLat() {
    if (this.isEmptyValue(this.params.lat)) {
      return this.trans('latEmpty');
    }
    return null;
  }

  validationLng() {
    if (this.isEmptyValue(this.params.lng)) {
      return this.trans('lngEmpty');
    }
    return null;
  }

  //street in backend is called as name
  validationStreet() {
    if (this.isEmptyValue(this.params.street)) {
      return this.trans('streetEmpty');
    }
    return null;
  }

  validationPostCode() {
    //skip validation if busstop is selected
    //bus stop dont have postcode
    if (this.isBusStop()) {
      return null;
    }

    if (this.isEmptyValue(this.params.postcode)) {
      return this.trans('postCodeEmpty');
    }
    return null;
  }

  validationType() {
    if (this.isEmptyValue(this.params.type)) {
      return this.trans('typeEmpty');;
    }
  }

  isValidForm() {
    return this.getError() === null;
  }

  isDuplicated(customerAddresses) {
    if (this.isBusStop()) {
      var element = find(
        customerAddresses,
        (o, key) => o.name === this.params.selectedObject.value
      );
    } else {
      var element = find(
        customerAddresses,
        (o, key) => o.name === this.params.selectedObject.label
      );
    }
    return element;
  }

  getError() {
    return mergeErrors(
      [
        this.validationLat(),
        this.validationLng(),
        this.validationStreet(),
        this.validationPostCode(),
        this.validationType(),
      ],
      true
    );
  }

  getRequestParams() {
    return {
      data: {
        lat: this.params.lat,
        lng: this.params.lng,
        //name is field in backend
        name: this.params.street,
        isBusStop: this.isBusStop(),
        postCode: this.params.postcode,
        type: this.params.type,
        googlePlaceId: this.params.googlePlaceId
      }
    }
  }

}